var _path, _g, _path2, _path3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoyaEuleriana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14047 19.0417H14.8596L14.3317 16.6667H6.66825L6.14047 19.0417ZM16.4815 19.0417H17.625V20.625H3.375V19.0417H4.51851L7.19557 6.99493C7.27606 6.63271 7.59733 6.375 7.96838 6.375H13.0316C13.4026 6.375 13.7239 6.63271 13.8044 6.99493L16.4815 19.0417ZM7.0201 15.0833H13.9799L13.2762 11.9167H7.72381L7.0201 15.0833ZM8.07566 10.3333H12.9243L12.3966 7.95833H8.60344L8.07566 10.3333Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5C5.53846 18.0518 8.13078 19.932 10.7692 18.5485C13.3333 17.204 17.4359 17.6522 20 18.1004L19.4872 16.3077L14.8718 5.99997L6.66667 5.99997L-1.82295e-06 18.1004C0.854698 18.3991 2.76923 18.8585 4 18.5Z",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5C11.5 3.94772 11.0523 3.5 10.5 3.5C9.94772 3.5 9.5 3.94772 9.5 4.5H11.5ZM11.5 7V4.5H9.5V7H11.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5V2.5",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 1.5,
    r: 1.5,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 18.5736C14.8842 18.1634 13.1486 18.3495 11.6915 19.0893C9.72278 20.0889 7.35542 20.2756 5.21675 19.6L2.5114 18.7453C2.11033 18.6186 1.90171 18.2292 2.04543 17.8757C2.18914 17.5221 2.63077 17.3381 3.03184 17.4648L5.73719 18.3195C7.44963 18.8605 9.34518 18.711 10.9215 17.9107C12.7414 16.9867 14.9089 16.7542 16.9269 17.2665L19.4418 17.9049C19.8512 18.0089 20.0876 18.3857 19.9697 18.7466C19.8518 19.1076 19.4243 19.3159 19.0149 19.212L16.5 18.5736Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8119 21.5542C15.7733 21.1421 13.6078 21.3434 11.7029 22.1109C9.31399 23.0734 6.57969 23.2667 4.0474 22.6307L0.556149 21.7539C0.14872 21.6515 -0.0868849 21.2792 0.0299114 20.9223C0.146708 20.5653 0.571676 20.3589 0.979105 20.4612L4.47036 21.3381C6.64496 21.8842 9.00189 21.7191 11.0616 20.8892C13.271 19.999 15.7831 19.764 18.157 20.244L21.405 20.9006C21.818 20.9841 22.0755 21.3451 21.9802 21.707C21.8849 22.0688 21.4728 22.2944 21.0598 22.2109L17.8119 21.5542Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyaEuleriana);
export default __webpack_public_path__ + "static/media/boya_euleriana.1ce334ebd4b04b82131144b67be5cd61.svg";
export { ForwardRef as ReactComponent };